<div class="d-flex">
  <div
    class="item-row clickable"
    [ngClass]="itemBackgroundClass(item)"
    (click)="toggleSelected(item)"
  >
    <div class="item-cell flex-column" style="flex: 1.65">
      <div>
        <b># {{ item.subProject.project.id }}</b>
      </div>

      <div
        *ngIf="item.subProject.project.oldPlatformId != null"
        class="font-weight-bold font-italic"
        [matTooltip]="'Jobnummer oud platform'"
      >
        ({{ item.subProject.project.oldPlatformId }})
      </div>
    </div>

    <div class="item-cell flex-3">
      <b [style.color]="typeDisplayMap[item.subProject.expectedType].color">
        {{ typeDisplayMap[item.subProject.expectedType].display }}
      </b>
    </div>

    <div class="item-cell flex-4">
      {{ item.subProject.project.companyNamesDisplay }}
    </div>

    <div class="item-cell flex-8">
      <ng-container
        *ngIf="item.subProject.expectedType === 'SoldRented'; else nonSticker"
      >
        <b>
          {{
            item.subProject.signSticker?.text
              | or : item.subProject.otherSticker
          }}
        </b>
      </ng-container>

      <ng-template #nonSticker>
        <ng-container
          *ngIf="
            item.subProject?.project?.firstProduct?.boardType?.ordinal ===
              BOARD_TYPE_CHOICES.DIVERGENT.ordinal;
            else regularBoard
          "
        >
          <b>
            <ng-container *ngIf="item.subProject.project.collaborative">
              Gezamenlijk
            </ng-container>
            {{ item.subProject?.project?.firstProduct?.type }}
            {{ BOARD_TYPE_CHOICES.DIVERGENT.label }}
          </b>
        </ng-container>

        <ng-template #regularBoard>
          <b>
            <ng-container *ngIf="item.subProject.project.collaborative">
              Gezamenlijk
            </ng-container>
            {{ item.subProject?.project?.firstProduct?.type }}
            {{ item.subProject?.project?.firstProduct?.format }} /
            {{ item.subProject?.project?.firstProduct?.title }}
          </b>
        </ng-template>
      </ng-template>
    </div>

    <div class="item-cell stock-cell flex-1">
      <ng-container *ngIf="item.subProject.expectedType !== 'SoldRented'">
        <label
          [matTooltip]="'Filiaal: ' + item.subProject.stockAtBranch"
          class="stock-info"
          *ngIf="!!item.subProject.stockAtBranch"
        >
          U
        </label>

        <label
          class="stock-info"
          *ngIf="item.subProject.project.firstProduct?.hasFrameCornerStock"
          [matTooltip]="
            'Toegewezen aantal: ' +
            item.subProject.project.firstProduct?.assignedFrameCornerStockAmount
          "
        >
          K
        </label>
      </ng-container>
    </div>

    <div class="item-cell" style="flex: 2.3">
      <ng-container
        *ngIf="
          item.subProject.expectedType == 'SoldRented';
          else nonStickerLocation
        "
      >
        <div>
          <div *ngIf="item.subProject.signSticker?.location?.length > 0">
            <b> {{ item.subProject.signSticker?.location }}</b>
          </div>
        </div>
      </ng-container>

      <ng-template #nonStickerLocation>
        <div>
          <div
            *ngIf="
              item.subProject.project.firstProduct?.defaultLocation?.length > 0
            "
          >
            <b (click)="openSign($event)">
              <!-- Rode tekst K / U
                  U = uitgesteld bord
                  K = Kader ??
              -->
              {{ item.subProject.project.firstProduct.defaultLocation }}
            </b>
          </div>

          <div
            *ngIf="
              item.subProject.project.firstProduct?.defaultLocationRight
                ?.length > 0
            "
          >
            <b (click)="openSign($event)">
              {{ item.subProject.project.firstProduct.defaultLocationRight }}
            </b>
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <div
    class="reviewed-flag"
    [ngClass]="itemBackgroundClass(item)"
    [class.reviewed]="item.checked?.reviewed"
  ></div>
</div>
